import React, {
    useEffect, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import animateScrollTo from 'animated-scroll-to';
import ScrollContainer from 'react-indiana-drag-scroll';
import ReactModal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import A1GA from '../../../helpers/A1GA';
import Button from '../../../common/button/Button';
import Spinner from '../../../common/Spinner/Spinner';
import DarkmodeIcon from '../Icons/pro_title_darkmode.svg';
import StreamsIcon from '../Icons/pro_title_streams.svg';
import PodcastsIcon from '../Icons/pro_title_podcasts.svg';
import AlarmIcon from '../Icons/pro_title_alarm.svg';

// Note: There is a bug with the modal.
// When the page was scrolled via the buttons (via animate-scroll-to) and the modal was then opened via the plans buttons
// the page scrolls to top when closing the modal.
// This is also somehow related to the hover effect of the plan cards. Removing it also fixes the problem.
// But if the page was not scrolled via animate-scroll-to, the problem does not happening, even with the hover animation.
// The current fix is to disable a accessibility feature and is not really nice. See comment on the props.
// I have posted a question about this here https://github.com/reactjs/react-modal/issues/680#issuecomment-996935797

const ProPageComponent = ({ proPageFaqs, fetchProPageFaqsIfNeeded }) => {
    useEffect(() => animateScrollTo(0, { speed: 700 }), []);

    useEffect(() => fetchProPageFaqsIfNeeded(), [fetchProPageFaqsIfNeeded]);

    const planosRef = useRef(null);
    const darkModeRef = useRef(null);
    const streamsRef = useRef(null);
    const podcastsRef = useRef(null);
    const alarmRef = useRef(null);
    const [openFaqIndex, setOpenFaqIndex] = useState(false);
    const [plansModalOpen, setPlansModalOpen] = useState(false);

    const hardcodedPodcasts = [
        {
            podcastName: 'Big Hour Antena 1',
            imgSrc: 'https://a1media.antena1.com.br/image/podcasts/thumbs/big-hour.png',
            link: '/podcasts/big-hour',
        },
        {
            podcastName: 'Antena 1 Noticias',
            imgSrc: 'https://a1media.antena1.com.br/image/podcasts/thumbs/noticias.png',
            link: '/podcasts/noticias',
        },
        {
            podcastName: 'Lado Pessoal',
            imgSrc: 'https://a1media.antena1.com.br/image/podcasts/thumbs/lado-pessoal.png',
            link: '/podcasts/lado-pessoal',
        },
        {
            imgSrc: false,
        },
        /* {
            podcastName: 'Antena 1 Artistas',
            imgSrc: 'https://a1media.antena1.com.br/image/podcasts/thumbs/artistas.png',
            link: '/podcasts/artistas',
        }, */
    ];

    const _logToGA = (label) => A1GA.event({
        category: 'pro-page',
        action: 'button-click',
        label,
        nonInteraction: false,
    });

    return (
        <div className="proPageContainer">
            <section className="sectionContainer promoBanner">
                <div className="sectionContent">
                    <h3 className="promoBannerSubtitle">
                        Torne-se um
                        <br />
                        <span style={{ fontWeight: 'bold' }}>assinante PRO!</span>
                    </h3>
                    <p>
                        Conheça todos os benefícios de se tornar
                        <br />
                        um assinante PRO da Antena 1, a rádio
                        <br />
                        número um em música.
                    </p>
                    <Button
                        title="Conheça os planos"
                        className="subscribeButton"
                        onClick={() => {
                            _logToGA('know-plans-promo');

                            animateScrollTo(planosRef.current, { speed: 700, verticalOffset: -30 });
                        }}
                    >
                        Conheça os planos
                    </Button>
                </div>
            </section>
            <section className="sectionContainer basicBlock titleBlock">
                <div className="sectionImage">
                    <div className="svgIconWrapper">
                        <DarkmodeIcon
                            className="svgIcon"
                            onClick={() => {
                                _logToGA('icon-darkmode');

                                animateScrollTo(darkModeRef.current, { speed: 700, verticalOffset: -30 });
                            }}
                        />
                        <StreamsIcon
                            className="svgIcon"
                            onClick={() => {
                                _logToGA('icon-streams');

                                animateScrollTo(streamsRef.current, { speed: 700, verticalOffset: -30 });
                            }}
                        />
                        <PodcastsIcon
                            className="svgIcon"
                            onClick={() => {
                                _logToGA('icon-podcasts');

                                animateScrollTo(podcastsRef.current, { speed: 700, verticalOffset: -30 });
                            }}
                        />
                        <AlarmIcon
                            className="svgIcon"
                            onClick={() => {
                                _logToGA('icon-alarm');

                                animateScrollTo(alarmRef.current, { speed: 700, verticalOffset: -30 });
                            }}
                        />
                    </div>
                </div>
                <div className="sectionContent right">
                    <h1>Conheça as vantagens da assinatura PRO da Antena 1</h1>
                    <h2 className="titleSubtitle">
                        Tudo o que
                        {' '}
                        <span style={{ fontWeight: 'bold' }}>você precisa,</span>
                        <br />
                        {' '}
                        do jeito que
                        {' '}
                        <span style={{ fontWeight: 'bold' }}>você gosta.</span>
                    </h2>
                    <p>
                        Muito mais conteúdo com a qualidade da sua radio favorita.
                        Tenha acesso a uma diversidade maior de streamings, notícias exclusivas e baixe seus podcasts para escutar em qualquer lugar.
                    </p>
                    <Button
                        title="Conheça os planos"
                        className="subscribeNowButton"
                        onClick={() => {
                            _logToGA('know-plans-title');

                            animateScrollTo(planosRef.current, { speed: 700, verticalOffset: -30 });
                        }}
                    >
                        Conheça os planos
                    </Button>
                </div>
            </section>
            <section className="sectionContainer basicBlock blueBackground reverseOnSmall streamsBlock" ref={streamsRef}>
                <div className="sectionImage">
                    <div className="streamsImagesContainer">
                        <div className="streamsImage antena1-hits" />
                        <div className="streamsImage antena1-2020" />
                        <div className="streamsImage antena1-hd" />
                        <div className="streamsImage antena1-mpb" />
                    </div>
                </div>
                <div className="sectionContent right">
                    <h2 className="sectionTitle">Streams</h2>
                    <p className="sectionParagraph">
                        Ouça seleções exclusivas que se encaixam perfeitamente no seu gosto e são sempre atualizadas.
                    </p>
                </div>
            </section>
            <section className="sectionContainer basicBlock podcastsBlock" ref={podcastsRef}>
                <div className="sectionContent left">
                    <h2 className="sectionTitle">Podcasts</h2>
                    <p className="sectionParagraph">
                        Sempre as melhores opções para você: Seja para se informar,
                        aumentar seu repertório ou simplesmente ouvir as melhores músicas dos melhores artistas.
                    </p>
                </div>
                <div className="podcastsContainer">
                    {hardcodedPodcasts.map((podcast) => (podcast.imgSrc ?
                        <Button key={podcast.podcastName} title={`Conheça o podcast ${podcast.podcastName}`} className="podcastItem" to={podcast.link}>
                            <img src={podcast.imgSrc} alt={`Imagem do podcast${podcast.podcastName}`} className="podcastItemImage" />
                        </Button> :
                        <Button key="allPodcasts" title="Conheça todos os nossos podcasts" className="podcastItem lastItem" to="/podcasts">
                            ...
                        </Button>))}
                </div>
            </section>
            <section className="sectionContainer basicBlock blueBackground reverseOnSmall darkModeBlock" ref={darkModeRef}>
                <div className="sectionImage" />
                <div className="sectionContent right">
                    <h2 className="sectionTitle">Darkmode</h2>
                    <p className="sectionParagraph">
                        Um visual escuro que te permite ler e navegar mais facilmente.
                        <br />
                        Porque você não precisa irritar seus olhos para agradar os seus ouvidos.
                    </p>
                </div>
            </section>
            <section className="sectionContainer basicBlock alarmBlock" ref={alarmRef}>
                <div className="sectionContent left">
                    <h2 className="sectionTitle">Despertador</h2>
                    <p className="sectionParagraph">
                        Comece o dia em grande estilo ao som de suas músicas preferidas.
                        <br />
                        O app da Antena 1 te acompanha por todos os momentos da sua jornada, da cama à cama.
                    </p>
                </div>
                <div className="sectionImage" />
            </section>
            <section className="sectionContainer plansBlock" ref={planosRef}>
                <div className="plansHeader">
                    <h2 className="plansTitle">
                        Comece agora
                        <br />
                        conheça o
                        {' '}
                        <span style={{ fontWeight: 'bold' }}>plano PRO.</span>
                    </h2>
                </div>
                <ScrollContainer className="plansContainer">
                    <div className="planOption promoBanner">
                        <h3 className="planPromoTitle">
                            Torne-se um Assinante
                            <br />
                            <span style={{ fontWeight: 'bold' }}>PRO</span>
                            {' '}
                            agora
                        </h3>
                        <p>
                            Junte-se a milhares de assinantes para ter acesso ao conteúdo exclusivo
                            e a todas funcionalidades PRO.
                        </p>
                    </div>
                    <div className="planOption monthly">
                        <div className="planHeader">
                            <h3 className="planTitle">
                                Plano
                                <br />
                                <span style={{ fontWeight: 'bold' }}>Mensal</span>
                            </h3>
                            <div className="planPrice">
                                { /* eslint-disable-next-line react/jsx-one-expression-per-line */}
                                <span className="currentPrice">R$<span className="currentPriceValue">9,90</span>/mês</span>
                            </div>
                        </div>
                        <div className="seperator" />
                        <h4>Benefícios:</h4>
                        <ul className="planFeatures">
                            <li>
                                <span className="checkmark" />
                                Download de podcasts
                            </li>
                            <li>
                                <span className="checkmark" />
                                Conteúdos exclusivos
                            </li>
                            <li>
                                <span className="checkmark" />
                                Streams exclusivos
                            </li>
                            <li>
                                <span className="checkmark" />
                                Rádio despertador
                            </li>
                            <li>
                                <span className="checkmark" />
                                Sem propagandas
                            </li>
                        </ul>
                        <div className="buttonContainer">
                            <div className="planFootNote">
                                Renovação mensal automática até solicitação de cancelamento
                            </div>
                            <Button
                                title="Assine ao plano mensal agora"
                                className="subscribePlanButton monthly"
                                onClick={() => {
                                    _logToGA('open-modal-monthly');

                                    setPlansModalOpen(true);
                                }}
                            >
                                Assinar agora
                            </Button>
                        </div>
                    </div>
                    <div className="planOption yearly">
                        <div className="planHeader">
                            <h3 className="planTitle">
                                Plano
                                <br />
                                <span style={{ fontWeight: 'bold' }}>Anual</span>
                            </h3>
                            <div className="planPrice">
                                <span className="oldPrice">R$118,80</span>
                                { /* eslint-disable-next-line react/jsx-one-expression-per-line */}
                                <span className="currentPrice">R$<span className="currentPriceValue">99,90</span>/ano</span>
                            </div>
                        </div>
                        <div className="seperator" />
                        <h4>Benefícios:</h4>
                        <ul className="planFeatures">
                            <li>
                                <span className="checkmark" />
                                Download de podcasts
                            </li>
                            <li>
                                <span className="checkmark" />
                                Conteúdos exclusivos
                            </li>
                            <li>
                                <span className="checkmark" />
                                Streams exclusivos
                            </li>
                            <li>
                                <span className="checkmark" />
                                Rádio despertador
                            </li>
                            <li>
                                <span className="checkmark" />
                                Sem propagandas
                            </li>
                            <li>
                                <span className="checkmark" />
                                <span style={{ color: '#fdd349' }}>2 meses grátis</span>
                            </li>
                        </ul>
                        <div className="buttonContainer">
                            <div className="planFootNote">
                                Renovação anual automática até solicitação de cancelamento
                            </div>
                            <Button
                                title="Assine ao plano anual agora"
                                className="subscribePlanButton yearly"
                                onClick={() => {
                                    _logToGA('open-modal-yearly');

                                    setPlansModalOpen(true);
                                }}
                            >
                                Assinar agora
                            </Button>
                        </div>
                    </div>
                </ScrollContainer>
                <ReactModal
                    isOpen={plansModalOpen}
                    onRequestClose={() => setPlansModalOpen(false)}
                    contentLabel="Modal Planos"
                    closeTimeoutMS={250}
                    overlayClassName="plansModalOverlay"
                    className="plansModalContainer"
                    shouldFocusAfterRender={false} // This is to resolve the modal bug (see comment on top of page).
                    // shouldReturnFocusAfterClose={false} // This would also resolve the modal bug.
                >
                    <Button title="fechar" className="plansModalCloseButton" onClick={() => setPlansModalOpen(false)}>
                        <FontAwesomeIcon icon={faTimes} className="closeButton" />
                    </Button>
                    <div className="plansModalContent">
                        <h2 className="plansModalTitle">Baixe o aplicativo pra se tornar PRO</h2>
                        <p className="plansModalP">
                            No momento não é possível fazer a assinatura pela página.
                            <br />
                            Baixa o aplicativo pro seu celular e efetue a assinatura por lá.
                        </p>
                        <p className="plansModalP">
                            Obs. A assinatura feito pelo aplicativo tambem é valida na página.
                        </p>
                        <div className="plansModalDownloadButtonsContainer">
                            <Button
                                className="downloadButton"
                                title="Baixa o aplicativo Android"
                                href="https://play.google.com/store/apps/details?id=br.com.antena1.app"
                                onClick={() => _logToGA('modal-link-to-playstore')}
                            >
                                <img src="/imgAplicativosPage/playstore-button-2x.png" alt="Icone baixar na Play Store" />
                            </Button>
                            <Button
                                className="downloadButton"
                                title="Baixa o aplicativo iOS"
                                href="https://itunes.apple.com/br/app/id1565020388"
                                onClick={() => _logToGA('modal-link-to-appstore')}
                            >
                                <img src="/imgAplicativosPage/appstore-button-2x.png" alt="Icone baixar na Apple Store" />
                            </Button>
                        </div>
                    </div>
                </ReactModal>
            </section>
            <section className="sectionContainer faqBlock">
                <div className="faqHeader">
                    <h2 className="faqTitle">FAQ</h2>
                    <p className="faqSubtitle">
                        Imaginamos que você possa ter algumas dúvidas.
                        Para deixar tudo mais claro, respondemos as perguntas mais frequentes:
                    </p>
                </div>
                <ul className="faqList">
                    {proPageFaqs.length > 0 ?
                        proPageFaqs.map((faqItem, index) => (
                            <li key={faqItem.question} className={`faqListItem ${index === openFaqIndex ? 'open' : ''}`}>
                                <h3 className="faqQuestion">
                                    <Button
                                        title={`Mostre a resposta para ${faqItem.question}`}
                                        className="questionButton"
                                        onClick={() => setOpenFaqIndex(index === openFaqIndex ? false : index)}
                                    >
                                        <div className="plusMinusSign" />
                                        <span>
                                            {faqItem.question}
                                        </span>
                                    </Button>
                                </h3>
                                {/* eslint-disable-next-line react/no-danger */}
                                <p className="faqAnswer" dangerouslySetInnerHTML={{ __html: faqItem.answer }} />
                            </li>
                        )) :
                        <Spinner />}
                </ul>
            </section>
        </div>
    );
};

ProPageComponent.propTypes = exact({
    proPageFaqs: PropTypes.arrayOf(PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
    })).isRequired,
    fetchProPageFaqsIfNeeded: PropTypes.func.isRequired,
});

export default ProPageComponent;
